import React from 'react';
import cx from 'classnames';
import { Icon } from 'assets/icons';
import styles from './banner.module.css';

export const InfoBanner = ({
  message = '',
  type = 'info', // info | error | warning | success
  show_icon = true
}) => {
  return (
    <div className={cx(styles.wrapper, styles[type])}>
      {show_icon && <Icon width={16} height={16} name="info" />}
      <div className={styles.message}>{message}</div>
    </div>
  );
};
